import { OnInit, Component } from "@angular/core";
import { MatDialogRef } from "@angular/material";
import { CommunicationPreviewDialog } from "./communication-preview.dialog";

@Component({
    selector: 'app-disable-confirmation-dialog',
    templateUrl: 'disable-confirmation.dialog.html',
    styleUrls: ['disable-confirmation.dialog.scss']
})
export class DisableConfirmationDialog implements OnInit {
    constructor(public dialogRef: MatDialogRef<CommunicationPreviewDialog>) {

    }

    ngOnInit(): void {

    }

    onYesClick(): void {
        this.dialogRef.close(true);
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}